<script setup>
defineProps({
	value: String,
});
</script>

<template>
	<label class="block font-medium text-dark-700 dark:text-dark-100">
		<span v-if="value">{{ value }}</span>
		<span v-else><slot/></span>
	</label>
</template>
